import { cloudApiClient } from '@/services/clientSideCloudApiService';

export const deletePublishedModel = async (id: number) => {
  await cloudApiClient.delete(`embeds/${id}`);
};
